import React, { useEffect, useState } from "react"
import SideBar from "../../common/layout/sidebar.component"
import { Tab, Tabs } from "react-bootstrap"
import { defineMessages, injectIntl } from "react-intl"
import { Intl } from "../../state/helpers/IntlProps"
import MyAccountTabs from "../../common/layout/tabs/myaccount.component"
import OrderStatusListing from "../../order-status/listing.component"
import RowCustomStatus from "../../pricing/rowcustomstatus/section/RowCustomStatusSection"

namespace STATUS {
    export const ORDER = "order-status"
    export const ORDER_ROW = "row-custom-status"
}
type STATUS = typeof STATUS[keyof typeof STATUS]

type Props = {
    intl: Intl
}

const tabMessage = defineMessages({
    [STATUS.ORDER]: {
        id: "status.page.status_page.order_status_tab",
        defaultMessage: "Order Status"
    },
    [STATUS.ORDER_ROW]: {
        id: "status.page.status_page.row_custom_status_tab",
        defaultMessage: "Order Row Status"
    },
})

const StatusPage = (props: Props) => {
    const [activeKey, setActiveKey] = useState(STATUS.ORDER)

    useEffect(() => {
        SideBar.activateMenu("account")
    }, [])

    const getContent = () => {
        switch (activeKey) {
        case STATUS.ORDER:
            return <OrderStatusListing />
        case STATUS.ORDER_ROW:
            return <RowCustomStatus />
        }
    }

    return (
        <>
            <MyAccountTabs />

            <Tabs activeKey={activeKey} className={"pt-2"} onSelect={k => setActiveKey(k as STATUS)}>
                <Tab
                    eventKey={STATUS.ORDER}
                    title={props.intl.formatMessage(tabMessage[STATUS.ORDER])}>
                </Tab>

                <Tab eventKey={STATUS.ORDER_ROW}
                    title={props.intl.formatMessage(tabMessage[STATUS.ORDER_ROW])}>
                </Tab>

            </Tabs>

            {getContent()}
        </>
    )
}

export default injectIntl(StatusPage)



// WEBPACK FOOTER //
// ./src/status/pages/StatusPage.tsx